import { render, staticRenderFns } from "./CardAvailability.vue?vue&type=template&id=197d2f5b"
import script from "./CardAvailability.vue?vue&type=script&lang=js"
export * from "./CardAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports